import React from "react";
import ReactModal from "react-modal";
import { WowcherCoupon } from "../../../../types/coupons";

import "./style.css";

interface Props {
  coupon: WowcherCoupon;
  closeModal: () => void;
  showModal: boolean;
}

export const CouponWowcherViewModal = ({
  coupon,
  closeModal,
  showModal,
}: Props) => {
  return (
    <div>
      {coupon && (
        <ReactModal
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          appElement={document.getElementById("root")}
          onClose={closeModal}
          isOpen={showModal}
          contentLabel="Inline Styles Modal Example"
          className="globalModalWrapper"
          style={{
            overlay: {
              backgroundColor: "rgba(9, 16, 29, 0.6)",
              zIndex: 10,
              width: "100%",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <div className="couponModalContentWrapper">
            <div className="modalHeader">
              <span>View Wowcher Coupon details</span>
            </div>
            <div className="modalBody_view">
              <div className="side side_left">
                <CouponDataBlock
                  title="Coupon #"
                  allowWhitespaces={true}
                  content={coupon.couponId}
                />
              </div>
            </div>
            <div className="modalBody_view">
              <div className="side side_left">
                <CouponDataBlock
                  title="Price"
                  allowWhitespaces={true}
                  content={`£${coupon.price.toString()}`}
                />
              </div>
              <div className="side side_right">
                <CouponDataBlock
                  title="Num of tickets"
                  allowWhitespaces={true}
                  content={coupon.value.toString()}
                />
              </div>
            </div>
            <div className="modalBody_view">
              <div className="side side_left">
                <CouponDataBlock
                  title="Status"
                  allowWhitespaces={true}
                  content={coupon.userEmail ? "Used" : "Active"}
                />
              </div>
              <div className="side side_right">
                {coupon.userEmail && (
                  <CouponDataBlock
                    title="Used By"
                    allowWhitespaces={true}
                    content={coupon.userEmail.toString()}
                  />
                )}
              </div>
            </div>
          </div>
        </ReactModal>
      )}
    </div>
  );
};

interface DataField {
  type?: "inline" | "default";
  title: string;
  content: string;
  allowWhitespaces?: boolean;
}

const CouponDataBlock = ({
  type,
  title,
  content,
  allowWhitespaces,
}: DataField) => (
  <div className={type === "inline" ? "row inline" : "row"}>
    <p className="fieldHeader">{title}</p>
    <p
      className={allowWhitespaces ? "fieldData allowWhitespaces" : "fieldData"}
    >
      <span>{content}</span>
    </p>
  </div>
);
